module.exports = __webpack_public_path__ + "static/media/client_book.e83e5aec.jpg";